export * from './paymentmethods.component';
